import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_USERSERVICE, API_MAP } from 'src/environments/api';
import { HtmlDocument } from '../common/htmlDocument';
import { CreateOrUpdateStaticHtmlDocumentRequest } from '../common/createOrUpdateStaticHtmlDocumentRequest';
import { HtmlDocumentVersion } from '../common/htmlDocumentVersion';
import { HtmlDocType } from '../common/htmlDocType';
import { map } from 'rxjs/operators';

const BASE = API_BASE_USERSERVICE;

@Injectable({ providedIn: 'root' })
export class StaticHtmlDocumentService {

  constructor(private http: HttpClient) {}

  listDocuments(): Observable<HtmlDocument[]> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.BASE;
    return this.http.get<HtmlDocument[]>(endpoint, { withCredentials: true }).pipe(
      map((documents) => documents.map((document) => HtmlDocument.fromJson(document)))
    );
  }

  createDocument(request: CreateOrUpdateStaticHtmlDocumentRequest): Observable<HtmlDocument> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.BASE;
    return this.http.post<HtmlDocument>(endpoint, request, { withCredentials: true }).pipe(
      map((document) => HtmlDocument.fromJson(document))
    );
  }

  updateDocument(documentId: number, request: CreateOrUpdateStaticHtmlDocumentRequest): Observable<HtmlDocument> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.BASE + '/' + documentId;
    return this.http.put<HtmlDocument>(endpoint, request, { withCredentials: true }).pipe(
      map((document) => HtmlDocument.fromJson(document))
    );
  }

  getCurrentVersion(documentId: number): Observable<HtmlDocumentVersion> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.CURRENT_VERSION.replace(':documentId', documentId.toString());
    return this.http.get<HtmlDocumentVersion>(endpoint, { withCredentials: true }).pipe(
      map((version) => HtmlDocumentVersion.fromJson(version))
    );
  }

  getCurrentVersionByType(documentType: HtmlDocType): Observable<HtmlDocumentVersion> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.CURRENT_BY_TYPE.replace(':documentType', documentType.toString());
    return this.http.get<HtmlDocumentVersion>(endpoint, { withCredentials: true }).pipe(
      map((version) => HtmlDocumentVersion.fromJson(version))
    );
  }

  getVersionById(versionId: number): Observable<HtmlDocumentVersion> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.VERSION_BY_ID.replace(':versionId', versionId.toString());
    return this.http.get<HtmlDocumentVersion>(endpoint, { withCredentials: true }).pipe(
      map((version) => HtmlDocumentVersion.fromJson(version))
    );
  }

  getVersionAt(documentId: number, atInstant: string): Observable<HtmlDocumentVersion> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.VERSION_AT.replace(':documentId', documentId.toString()).replace(':atInstant', atInstant);
    return this.http.get<HtmlDocumentVersion>(endpoint, { params: { at: atInstant }, withCredentials: true }).pipe(
      map((version) => HtmlDocumentVersion.fromJson(version))
    );
  }

  getVersions(documentId: number): Observable<HtmlDocumentVersion[]> {
    let endpoint = BASE + API_MAP.staticHtmlDocuments.VERSIONS.replace(':documentId', documentId.toString());
    return this.http.get<HtmlDocumentVersion[]>(endpoint, { withCredentials: true }).pipe(
      map((versions) => versions.map((version) => HtmlDocumentVersion.fromJson(version)))
    );
  }
}
